import script from "./HowItWorks.vue?vue&type=script&setup=true&lang=js"
export * from "./HowItWorks.vue?vue&type=script&setup=true&lang=js"

import "./HowItWorks.vue?vue&type=style&index=0&id=a5733720&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5733720"]])

export default __exports__